import React from 'react';
import { Grid } from '@mui/material';
import AppLayout from '../../layout/app.layout';
import WatchedSessionsChart from '../../components/reports/watched-sessions-chart.component';
import DownloadReports from '../../components/reports/download-reports.component';
import PAGE_TITLE_LIST from '../../config/page-title.config';
import PieChart from '../../components/reports/piechart.component';

const ReportsOverviewView = () => {
  const pageTitle = PAGE_TITLE_LIST.REPORTS_OVERVIEW_VIDEOS;

  return (
    <AppLayout pageTitle={pageTitle}>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={12} md={6}>
          <WatchedSessionsChart />
        </Grid>

        <Grid item xs={12} sm={12} md={6}>
          <PieChart />
        </Grid>

        <Grid item xs={12} sm={12} md={6}>
          <DownloadReports />
        </Grid>
      </Grid>
    </AppLayout>
  );
};

export default ReportsOverviewView;
